var lib_core = require("lib-core");

var TooltipStateMachine = function (root, model) {
    var self = this;

    this.root = root;
    this.model = model;

    lib_core.StateMachine.call(self, null, null, this.model.scope());

    self.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.UI_TOOLTIP_SHOW;
        },
        function(cEvent){
            self.model.title(cEvent.data('title'));
            self.model.direction(cEvent.data('direction'));
            self.model.position(cEvent.data('position'));
            self.model.visible(true);
        }
    );

    self.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.UI_TOOLTIP_HIDE;
        },
        function(cEvent){
            self.model.visible(false);
        }
    );
};

lib_core.inherit(TooltipStateMachine, lib_core.StateMachine);

module.exports = TooltipStateMachine;
